
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Vaciado de pisos',
    description: 'Servicio completo de vaciado de viviendas, casas y áticos en Vic y comarca. Retiramos todos los muebles y enseres de forma rápida y profesional.',
    link: '/servicios#vaciado-pisos',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Vaciado de locales',
    description: 'Vaciado integral de locales comerciales, oficinas y naves industriales. Servicio adaptado a las necesidades de tu negocio.',
    link: '/servicios#vaciado-locales',
  },
  {
    icon: 'ri-truck-line',
    title: 'Retirada de muebles',
    description: 'Recogida y transporte de muebles y electrodomésticos. Gestión legal de residuos incluida. Servicio mínimo: una furgoneta llena.',
    link: '/servicios#retirada-muebles',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Limpieza Diógenes',
    description: 'Servicio especializado y discreto para casos de síndrome de Diógenes. Equipo formado específicamente para estas situaciones delicadas.',
    link: '/servicios#diogenes',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Limpieza extrema',
    description: 'Limpieza profunda y desinfección en casos de suciedad extrema. Utilizamos productos profesionales para garantizar resultados óptimos.',
    link: '/servicios#limpieza-extrema',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Pintura y reparaciones',
    description: 'Servicio complementario de pintura y pequeñas reparaciones para dejar tu espacio completamente listo.',
    link: '/servicios#pintura-reparaciones',
  },
];

export default function ServicesSection() {
  return (
    <section id="servicios" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-4 sm:mb-6">
            Nuestros servicios en Vic
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ofrecemos soluciones completas de <strong>vaciado de pisos y locales</strong>, <strong>limpieza por síndrome de Diógenes</strong> y <strong>retirada de muebles</strong> en Vic, Manlleu, Torelló y toda la comarca de Osona. <Link to="/empresa" className="text-primary hover:text-red-700 font-semibold">Conoce más sobre nuestra empresa</Link> y nuestros más de 10 años de experiencia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-product-shop>
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-lg p-6 sm:p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group border border-gray-100"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-primary/10 rounded-lg mb-4 sm:mb-6 group-hover:bg-primary/20 transition-colors flex-shrink-0">
                <i className={`${service.icon} text-3xl sm:text-4xl text-primary`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-dark mb-3 sm:mb-4 break-words">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4 sm:mb-6 leading-relaxed break-words">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="inline-flex items-center text-sm font-semibold text-primary hover:text-red-700 transition-colors group-hover:gap-2 gap-1"
                aria-label={`Más información sobre ${service.title}`}
              >
                Más información
                <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <Link
            to="/servicios"
            className="inline-block bg-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl text-sm whitespace-nowrap"
            aria-label="Ver todos nuestros servicios de vaciado y limpieza"
          >
            Ver todos los servicios
          </Link>
        </div>
      </div>
    </section>
  );
}
